import { updateSpacings } from './spacings';
import { updateRadiuses } from './radiuses';

const htmlClasses = {
  dark: 'dark',
  light: 'light',
};

const updateHtmlClassName = (className: string) => {
  const htmlElement = document.querySelectorAll('html')[0];

  Object.values(htmlClasses).forEach(el => {
    htmlElement.classList.remove(el);
  });

  htmlElement.classList.add(className);
};

const toggleHtmlClassName = (isDarkModeEnabled: boolean) => updateHtmlClassName(isDarkModeEnabled ? htmlClasses.dark : htmlClasses.light);

const configureDefaultTheme = () => {
  const cleanupSpacings = updateSpacings();
  const cleanupRadiuses = updateRadiuses();

  return () => {
    cleanupSpacings();
    cleanupRadiuses();
  };
};

export { updateSpacings, toggleHtmlClassName, configureDefaultTheme };
